<template>
    <v-container>
        <div v-if="!dataLoadFailed">
            <v-select v-model="selectedHallitusUuid" :items="hallitukset" item-value="uuid" :item-text="getHallitusNimi" label="Hallitus"></v-select>
            <HoRakenneElementtiSelector v-if="selectedHallitusUuid" v-model="selectedRakenneElementtiUuid" :hallitus-uuid="selectedHallitusUuid" :json-api="jsonApi"/>
            <v-btn color="primary" x-large right @click="saveConfigurationDataToInput"><span v-translate>save</span></v-btn>
        </div>
        <div v-else>
            <Alert>
                <span v-translate>error.getting.data</span>
            </Alert>
        </div>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import HoRakenneElementtiSelector from "./HoRakenneElementtiSelector"
    import Alert from "./Alert"

    export default {
        components: {HoRakenneElementtiSelector, Alert},
        props: {
            configurationData: Object,
            jsonApi: String
        },
        data: function() {
            return {
                hallitukset: [],
                selectedHallitusUuid: null,
                selectedRakenneElementtiUuid: null,
                dataLoadFailed: false
            }
        },
        beforeMount: function() {
            this.selectedHallitusUuid = this.configurationData.hallitusUuid;
            this.selectedRakenneElementtiUuid = this.configurationData.rakenneElementtiUuid;
        },
        mounted: function() {
            this.loadHallitukset();
        },
        methods:  {
            getHallitusNimi(hallitus) {
                return hallitus.nimi.fi;
            },
            loadHallitukset() {
                axios
                    .get(this.jsonApi + '/hankeikkuna-government-timeline/data/hallitukset')
                    .then(response => this.hallitukset = response.data)
                    .catch(() => this.dataLoadFailed = true)
            },
            getConfigurationData() {
                return {
                    hallitusUuid: this.selectedHallitusUuid,
                    rakenneElementtiUuid: this.selectedRakenneElementtiUuid
                }
            },
            saveConfigurationDataToInput() {
                const container = document.getElementById('app-selection');
                if (container) {
                    const form = container.querySelectorAll('form')[0];
                    const fields = form.querySelectorAll('input[type="hidden"]');
                    let field = this.getFieldById(fields, 'applicationConfiguration');
                    field.value = JSON.stringify(this.getConfigurationData());
                    form.submit();
                }
            },
            getFieldById(items, id) {
                for (let i = 0; i < items.length; i++) {
                    let item = items[i];
                    if (item.id.includes(id)) {
                        return item;
                    }
                }
            }
        }
    }
</script>